/**
 * Initialize Swiper sliders for the Events Slider flex component
 *
 * Centered carousel: the active slide grows via CSS (.swiper-slide-active).
 * The caption under the slider is synced to the active slide.
 */

/* global Swiper, jQuery */

jQuery(document).ready(function ($) {
  if (!$('.events-slider-carousel').length) {
    return;
  }

  $('.events-slider-carousel').each(function (index) {
    const $slider = $(this);
    const $outerContainer = $slider.closest('.events-slider-outer-container');
    const sliderId = `events-slider-${index}`;
    const outerContainerId = `events-slider-outer-${index}`;

    if (!$outerContainer.length) {
      return;
    }

    $slider.attr('id', sliderId);
    $outerContainer.attr('id', outerContainerId);
    $slider.addClass('swiper');

    const minSlides = Math.ceil(window.innerWidth / 350) * 2 + 2;
    const $wrapper = $slider.find('.swiper-wrapper');
    const $originalSlides = $wrapper.find('.swiper-slide');

    if ($originalSlides.length && $originalSlides.length < minSlides) {
      const copies = Math.ceil(minSlides / $originalSlides.length) - 1;
      for (let i = 0; i < copies; i++) {
        $originalSlides.clone().appendTo($wrapper);
      }
    }

    function updateSideClasses(swiperInstance) {
      swiperInstance.slides.forEach(function (slideEl, i) {
        slideEl.classList.toggle('is-left', i < swiperInstance.activeIndex);
        slideEl.classList.toggle('is-right', i > swiperInstance.activeIndex);
      });
    }

    // Function to update slide info
    function updateSlideInfo(swiperInstance) {
      const $activeSlide = $(swiperInstance.slides[swiperInstance.activeIndex]);
      const slideId = $activeSlide.data('slide-id');

      const $contentBlock = $outerContainer.find(`.slide-data[data-slide-id="${slideId}"]`);
      const $slideInfo = $outerContainer.find('.slider-info');

      if ($contentBlock.length && $slideInfo.length) {
        // Fade out effect
        $slideInfo.fadeOut(200, function () {
          $slideInfo.html($contentBlock.html()).fadeIn(200);
        });
      }
    }

    // Initialize Swiper with navigation
    new Swiper(`#${sliderId}`, {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16,
      loop: true,
      loopAdditionalSlides: 2,
      speed: 400,
      // Swiper navigation
      navigation: {
        nextEl: `#${outerContainerId} .slider-next`,
        prevEl: `#${outerContainerId} .slider-prev`,
      },
      breakpoints: {
        768: {
          spaceBetween: 24,
        },
        1024: {
          spaceBetween: 30,
        },
      },
      on: {
        slideChange: function () {
          updateSlideInfo(this);
          updateSideClasses(this);
        },
        init: function () {
          updateSlideInfo(this);
          updateSideClasses(this);
        },
        loopFix: function () {
          updateSideClasses(this);
        },
      },
    });
  });
});
